import { Config } from "../../../configurations/config";

export const ResourceLeavesInfo_API = {
	//----------------------------- Employee Leaves Listing --------------------------------------//
	GetEmployeesListLeaves: `${Config.server_url}${Config.api_prefix}/Leave/GetResourceLeaveInfo`,
	EmployeesListLeavesExportToExcel: `${Config.server_url}${Config.api_prefix}/Leave/GetResourceLeaveInfo/ExportToExcel`,


	//------------------------ Supervisor ROle -Resource Leaves Info APIS -----------------------//
	GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
	GetResourceLeavesInfoById: `${Config.server_url}${Config.api_prefix}/Leave/GetResourceLeaveInfo`,

	//------------------------ Admin ROle -Resource Leaves Info APIS -----------------------//

	PUTResourceLeaveInfo: `${Config.server_url}${Config.api_prefix}/Leave/GetResourceLeaveInfo`,
	GetAdminEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees?AllEmployees=true `,
	GetActiveInActiveEmployee: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees?AllEmployees`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/Leave/GetResourceLeaveInfo/ExportToExcel`,
};
